// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"078e07f3","455":"521cf557","977":"e3cfb2be"}[chunkId] + ".chunk.js";
};